import React from 'react'
import moment from 'moment'
import EPCRCard from '../../../../components/Cards/EPCRCard'
import { Grid, Link, Typography } from '@mui/material'
import DetailsBox, { DetailRow } from '../../../../components/Cards/DetailsBox'

const TimeBlock = ({ label, value }) => (
  <Grid item xs={12} sm={6} md={4} lg={3} xl={2}>
    <DetailRow label={label} value={value && moment(value).format('HH:mm')} />
  </Grid>
)
// The server-frozen snapshots include subcontractors, whose IDs never resolve
// through the employee populate — prefer them so staff stay visible after a
// subcontractor's access window lapses. Older records fall back to populate.
const staffInvolvedNames = (incident) => {
  const records = (incident?.staffInvolvedRecords || []).filter((x) => x?.name)
  if (records.length > 0) {
    return records
      .map((x) =>
        [
          x.name,
          x.clinicalRole && `(${x.clinicalRole})`,
          x.personType === 'Subcontractor' && '[Subcontractor]',
        ]
          .filter(Boolean)
          .join(' '),
      )
      .join(', ')
  }

  if (incident?.staffInvolved?.length > 0) {
    return incident.staffInvolved
      .map(
        (x) =>
          x.userAccount?.firstName +
          ' ' +
          x.userAccount?.lastName +
          ' (' +
          x.clinicalRole +
          ')',
      )
      .join(', ')
  }

  return 'None'
}

const IncidentModule = ({ incident }) => {
  return (
    <>
      <DetailsBox
        title="Incident Details"
        rows={[
          {
            label: 'Incident Date',
            value: moment(incident.incidentDate).format('Do MMM YYYY HH:mm'),
          },
          {
            label: 'Linked Event',
            value: incident?.linkedEvent?.title ? (
              <Link
                href={`/events/${incident?.linkedEvent?._id}`}
                target="_blank"
              >
                {incident.linkedEvent.title}
              </Link>
            ) : (
              'None'
            ),
          },
          {
            label: 'Incident Location',
            value: incident?.incidentLocation,
            fullWidth: true,
          },
          { label: 'Incident Type', value: incident.incidentType },
          ...(incident.incidentType === 'Event'
            ? [
                {
                  label: 'Occurred at Event',
                  value: incident.injuryOccurredAtEvent || 'Not recorded',
                },
              ]
            : []),
          { label: 'Reported By', value: incident.reportedBy },
          {
            label: 'Reported Complaint',
            value: incident.reportedComplaint,
            fullWidth: true,
          },
        ]}
      >
        <DetailRow
          label="Vehicles Involved"
          value={
            incident?.incidentVehicles?.length > 0
              ? incident.incidentVehicles.map((x) => x.callSign).join(', ')
              : 'None'
          }
        />
        <DetailRow label="Staff Involved" value={staffInvolvedNames(incident)} />
      </DetailsBox>
      <DetailsBox title="Response Times">
        <Grid container spacing={1}>
          <TimeBlock label="Call Time" value={incident.callTime} />
          <TimeBlock label="Dispatched" value={incident.dispatchTime} />
          <TimeBlock label="At Scene" value={incident.atSceneTime} />
          <TimeBlock label="With PT" value={incident.patientSideTime} />
          <TimeBlock label="Leave" value={incident.leaveSceneTime} />
          <TimeBlock label="At Hosp" value={incident.arriveHospitalTime} />
          <TimeBlock label="Handover" value={incident.patientHandoverTime} />
          <TimeBlock label="Clear" value={incident.clearTime} />
        </Grid>
      </DetailsBox>
    </>
  )
}

export default IncidentModule
